import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { UpdateMenuCommand } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { FileTypePipe } from 'src/app/core/pipes/file-type.pipe';
import { ApiNotificationService } from 'src/app/core/services/api-notification.service';
import { AppConfigService } from 'src/app/core/services/config.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { LoggerService } from 'src/app/core/services/logger.service';
import { HelpFileTypes } from '../../../../../../core/api/models/help-file-types';
import { MenusService } from '../../../../../../core/api/services/menus.service';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { AppDomService } from './../../../../../../core/services/dom.service';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { ModalTitleComponent } from "../../../../../../shared/global/modal-title/modal-title.component";


@Component({
    selector: 'app-file-manager',
    templateUrl: './file-manager.component.html',
    styleUrls: [`./file-manager.component.scss`],
    imports: [BaseIndexModule, ModalTitleComponent, FormsModule, ReactiveFormsModule]
})
export class FileManagerComponent implements OnInit {
  //#region properties
  url: string = AppConfigService.config.apiUrl;
  model: UpdateMenuCommand = {};
  files: any[] = [];
  menuId: number;
  protected onDestroy$ = new Subject<void>();
  loading: boolean;
  form: FormGroup;
  fields;

  //#endregion

  constructor(
    public apiNotificationService: ApiNotificationService,
    protected currentService: MenusService,
    public dialogService: DialogService,
    private fileType: FileTypePipe,
    private dialogRef: MatDialogRef<FileManagerComponent>,
    private loggerService: LoggerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.menuId = data?.menuId;
    this.loading = true;
    this.fields = 'pages.menus.uploadFileForm.fields.';
  }

  ngOnInit() {
    try {
      this.initForm();
      this.getFiles();
    } catch (error) {
      this.loggerService.logError(
        'app-file-manager',
        error,
        EventTypes.infrastructure
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      file: new FormControl(''),
    });
  }

  onUploadFile() {
    try {
      const modalResult = this.dialogService.openModal({
        component: FileUploadComponent,
        data: this.menuId,
      });
      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe(() => this.getFiles());
    } catch (error) {
      this.loggerService.logError(
        'app-file-manager',
        error,
        EventTypes.infrastructure
      );
    }
  }

  getFiles() {
    this.files = [];
    this.currentService
      .menusUpdateMenuHelpsGet({ Id: this.menuId })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((files) => {
        try {
          ['pdfHelp', 'videoHelp', 'fileHelp', 'imageHelp'].forEach((key) => {
            const file = files.data?.[key];
            if (file) {
              this.files.push(file);
            }
          });
          this.loading = false;
        } catch (error) {
          this.loggerService.logError(
            'app-file-manager',
            error,
            EventTypes.infrastructure
          );
        }
      });
  }

  showDeleteDialog(event: MouseEvent, file) {
    try {
      event.preventDefault();
      let fileName = file.substr(file.indexOf('/') + 1);
      let dialogResult = this.dialogService.confirmDialog({
        isConfirmDelete: true,
      });
      dialogResult.afterClosed().subscribe((result) => {
        if (result) {
          this.baseDeleteApi(fileName);
        }
      });
    } catch (error) {
      this.loggerService.logError(
        'app-file-manager',
        error,
        EventTypes.infrastructure
      );
    }
  }
  //Delete
  baseDeleteApi(file: string) {
    this.unSubs();
    this.loading = true;
    let fileType;

    fileType = this.getHelpFileType(file);

    // this.currentService
    //   .menusDeleteHelpFiles({
    //     body: { fileName: file, menuId: this.menuId, helpFileType: fileType },
    //   })
    //   .pipe(
    //     finalize(() => (this.loading = false)),
    //     takeUntil(this.onDestroy$)
    //   )
    //   .subscribe(
    //     (result: CustomResult) => {
    //       this.apiNotificationService.notifyMessage({ result });
    //       if (result.isSucceed) this.getFiles();
    //     },
    //     (error) => ConsoleService.error('error', error),
    //     () => (this.loading = false)
    //   );
  }

  getHelpFileType(file) {
    try {
      let type = this.fileType.transform(file);
      let fileType;

      switch (type) {
        case 'image':
          fileType = HelpFileTypes.Image;
          break;
        case 'video':
          fileType = HelpFileTypes.Video;
          break;
        case 'pdf':
          fileType = HelpFileTypes.Pdf;
          break;
        case 'file':
          fileType = HelpFileTypes.File;
          break;
      }
      return fileType;
    } catch (error) {
      this.loggerService.logError(
        'app-file-manager',
        error,
        EventTypes.infrastructure
      );
    }
  }

  selectFile(file) {
    this.onClose(file);
  }

  onClose(file) {
    this.dialogRef.close({ close: false, file: file, model: this.model });
    this.unSubs();
  }

  onSuccess() {
    this.unSubs();
  }

  unSubs() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
